import { authHeader } from '@/_helpers';
import {userService} from "@/_services/user.service";
import {API_URL} from "../config/app";

const URL = API_URL

export const taxDataService = {
  getAll,
  createTaxData,
  updateTaxData
}

function getAll(page, sort, search) {

  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  let parameters = '';
  if (page) {
    parameters += '&page=' + page
  }
  if (sort) {
    parameters += '&sort=' + sort
  }

  return fetch(URL + "/users/invoices_data" + parameters, requestOptions)
    .then(handleResponse)
    .then(response => {

      let data = [];
      response.data.forEach(resp => {
        data.push({
          id: resp.id,
          company: resp.attributes.company,
          rfc: resp.attributes.rfc,
          use_cfdi: resp.attributes.use_cfdi,
          location_code: resp.attributes.location_code,
          regimen_fiscal: resp.attributes.regimen_fiscal,
          default: resp.attributes.default,
          created_at: resp.attributes.created_at,
        });
      })

      return Promise.resolve({
        data,
        pagination: response.meta[0].page
      })
    })

}

function createTaxData(taxData) {
  let formData = new FormData()
  formData.append("razon_social", taxData.company);
  formData.append("rfc", taxData.rfc);
  formData.append("cfdi_use", taxData.use_cfdi);
  formData.append("location_code", taxData.location_code);
  formData.append("regimen_fiscal", taxData.regimen_fiscal);
  formData.append("selected", taxData.default);

  let headers = authHeader();
  delete headers['Content-Type']

  const requestOptions = {
    method: 'POST',
    headers: headers,
    body: formData
  };

  return fetch(URL + "/users/invoices_data", requestOptions).then(handleResponse);
}

function updateTaxData(taxData) {
  let formData = new FormData()
  formData.append("razon_social", taxData.company);
  formData.append("rfc", taxData.rfc);
  formData.append("cfdi_use", taxData.use_cfdi);
  formData.append("location_code", taxData.location_code);
  formData.append("regimen_fiscal", taxData.regimen_fiscal);
  formData.append("selected", taxData.default);

  let headers = authHeader();
  delete headers['Content-Type']

  const requestOptions = {
    method: 'PATCH',
    headers: headers,
    body: formData
  };

  return fetch(URL + "/users/invoices_data/" + taxData.id, requestOptions).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        userService.refreshToken();
        return Promise.reject("Intentando recuperar la sesión");
      }

      const error = (data && data.errors[0].detail) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}
